export const MEETING_URL = "https://meetings.hubspot.com/melissazabala";

export function bookingUrl(contact?: { firstname: string; lastname: string; email: string }) {
  const url = new URL(MEETING_URL);
  url.searchParams.set("embed", "true");
  // HubSpot uses these values to identify reservations made from this landing.
  url.searchParams.set("utm_source", "web-Leads-Franquicias-2026");
  url.searchParams.set("utm_medium", "landing");
  url.searchParams.set("utm_campaign", "reserva-Leads-Franquicias-2026");
  if (contact) {
    url.searchParams.set("firstName", contact.firstname);
    url.searchParams.set("lastName", contact.lastname);
    url.searchParams.set("email", contact.email);
  }
  return url.toString();
}
